import React from 'react'

import { type SurveyStep } from '../module/survey/types'

import ExamKeywordSelect from './ExamKeywordSelect'
import LearnerGroupSelect from './LearnerGroupSelect'
import SurveyFormLayout from './surveyFormLayout'
import UserNicknameSelect from './UserNicknameSelect'

interface SurveyFormProps {
  onFormLoad?: () => void
  onSubmitSuccess?: () => void
}

// V2: [닉네임 → 시험 선택 → 그룹 선택] 고정 순서.
// 학교/학과/학년도/학년/반 스텝(V1)은 미수집으로 제거됨.
export default function SurveyForm(props: SurveyFormProps) {
  const steps: Array<{ step: SurveyStep; component: React.ReactNode }> = [
    { step: 'userNickname', component: <UserNicknameSelect /> },
    { step: 'examinations', component: <ExamKeywordSelect /> },
    { step: 'userGroup', component: <LearnerGroupSelect /> },
  ]

  return (
    <SurveyFormLayout>
      <SurveyFormLayout.ProgressBar />
      <SurveyFormLayout.Form onFormLoad={props.onFormLoad} onSubmitSuccess={props.onSubmitSuccess}>
        {steps.map(({ step, component }) => (
          <SurveyFormLayout.Contents key={step} step={step}>
            {component}
          </SurveyFormLayout.Contents>
        ))}
      </SurveyFormLayout.Form>
    </SurveyFormLayout>
  )
}
